import { INavigationService, ENVIRONMENT_TOKEN } from '@aksia/infrastructure';
import { inject, Injectable, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { filter } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavigationService implements INavigationService, OnInit {
  //#region Injections

  private readonly env = inject(ENVIRONMENT_TOKEN);
  private readonly router = inject(Router);
  private readonly activatedRoute = inject(ActivatedRoute);

  //#endregion

  //#region Properties

  previousUrl: string = '';
  currentUrl: string = '';

  //#endregion

  //#region Init

  // TODO: ngOnInit never runs on services — move to constructor or APP_INITIALIZER.
  // eslint-disable-next-line @angular-eslint/contextual-lifecycle
  ngOnInit() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      });
  }

  //#region Functions

  public goToPage(url: string, newTab: boolean = false) {
    if (!newTab) {
      this.router.navigate([`${url}`]);
    } else {
      let newRelativeUrl = this.router.createUrlTree([url]);
      let baseUrl = window.location.href.replace(this.router.url, '');

      window.open(baseUrl + newRelativeUrl, '_blank');
      //window.open(`${this.env.app_url}${url}`, '_blank');
    }
  }

  public goToExternalPage(url: string, newTab: boolean = false) {
    if (!newTab) {
      window.location.href = url;
    } else {
      window.open(url, '_blank');
    }
  }

  public addQueryParams(params: Params) {
    let queryParams = {
      ...this.activatedRoute.snapshot.queryParams,
      ...params,
    };
    this.router.navigate([], {
      queryParams,
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'replace',
    });
  }

  public removeQueryParams(params: Params) {
    let queryParams = { ...this.activatedRoute.snapshot.queryParams };

    for (const key of Object.keys(params)) {
      delete queryParams[key];
    }

    this.router.navigate([], {
      queryParams,
      relativeTo: this.activatedRoute,
      queryParamsHandling: 'replace',
    });
  }

  public getQueryParamValue(paramName: string): string | null {
    return this.activatedRoute.snapshot.queryParams[paramName] ?? null;
  }

  public getPreviousUrl(): string {
    return this.previousUrl;
  }

  //#endregion
}
